module.exports = __webpack_public_path__ + "static/media/srm_logo.cb5225e6.png";